import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { admin } from './admin/adminUi';

/**
 * Client-side table pagination (Prev / numbered / Next).
 * Renders nothing when total is 0 or when everything fits on one page.
 */
const TablePagination = ({ page, pageSize, total, onPageChange, className = '' }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0 || pages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  const go = (next) => {
    if (next >= 1 && next <= pages) onPageChange(next);
  };

  return (
    <div
      className={`flex flex-col gap-3 border-t border-[#FFFFFF10] bg-[#FFFFFF04] px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${className}`}
    >
      <div className={`text-sm ${admin.tdMuted}`}>
        Showing {from} to {to} of {total}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => go(page - 1)}
          disabled={page === 1}
          className={`${admin.btnSecondary} py-2 disabled:cursor-not-allowed disabled:opacity-40`}
        >
          <FiChevronLeft size={18} />
          <span>Prev</span>
        </button>
        <div className="flex flex-wrap gap-1">
          {Array.from({ length: Math.min(5, pages) }, (_, i) => {
            let pageNum;
            if (pages <= 5) {
              pageNum = i + 1;
            } else if (page <= 3) {
              pageNum = i + 1;
            } else if (page >= pages - 2) {
              pageNum = pages - 4 + i;
            } else {
              pageNum = page - 2 + i;
            }
            return (
              <button
                key={pageNum}
                type="button"
                onClick={() => go(pageNum)}
                className={
                  page === pageNum
                    ? `${admin.btnPrimary} min-w-[2.5rem] py-2`
                    : `${admin.btnSecondary} min-w-[2.5rem] py-2`
                }
              >
                {pageNum}
              </button>
            );
          })}
        </div>
        <button
          type="button"
          onClick={() => go(page + 1)}
          disabled={page === pages}
          className={`${admin.btnSecondary} py-2 disabled:cursor-not-allowed disabled:opacity-40`}
        >
          <span>Next</span>
          <FiChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
